/** After a lifecycle write: re-read everything that shows a tenant's lifecycle — the operator
 *  record (its banner), the grids and the picker lists, the Lifecycle and Sandbox tabs (a close
 *  suspends the sandbox; all under `tourOperators`) — and the tenant-requests grid. */
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { tenantRequestsKeys } from '@/api/tenantRequests';

export function useLifecycleRefresh(): () => void {
  const qc = useQueryClient();
  return useCallback(() => {
    void qc.invalidateQueries({ queryKey: ['tourOperators'] });
    void qc.invalidateQueries({ queryKey: tenantRequestsKeys.all });
  }, [qc]);
}
